import React, { memo, useEffect, useState } from 'react';
import { TouchableOpacity, View, } from 'react-native';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, TextAlignTokens } from '@voltmoney/schema';
import { Typography } from "../typography/Typography";
/**
 * Primary UI component for user interaction
 */
const PartnerDetailsCard = ({ title, detailItems, actionItems, action, triggerAction }) => {
    const [_actionsItems, setActionItems] = useState(actionItems);
    useEffect(() => {
        const actionItemTemp = _actionsItems.filter(obj => Object.keys(obj).length !== 0);
        setActionItems(actionItemTemp);
        console.log("actionItemTemp: ", actionItemTemp);
    }, []);
    const handeAction = (index) => {
        _actionsItems &&
            _actionsItems[index] &&
            triggerAction(_actionsItems[index].action);
    };
    return (React.createElement(View, { style: {
            backgroundColor: '#FFFFFF',
            borderWidth: 1,
            borderColor: '#E4E7EC',
            borderRadius: 8,
            elevation: 4,
            shadowColor: '#000',
            shadowOffset: {
                width: 0,
                height: 2,
            },
            shadowOpacity: 0.25,
            shadowRadius: 4,
            width: '100%',
        } },
        React.createElement(View, { style: {
                width: '100%',
                paddingTop: 12,
                paddingBottom: 4,
                paddingHorizontal: 12,
                display: 'flex',
                flexDirection: 'column'
            } },
            React.createElement(View, { style: {
                    paddingBottom: 8
                } }, title &&
                React.createElement(Typography, { label: title, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24 })),
            React.createElement(View, null, detailItems && detailItems.map((item, index) => (React.createElement(View, { style: {
                    paddingBottom: 8
                } },
                React.createElement(Typography, { label: `${item.title}: ${item.value}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 18 })))))),
        React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center'
            } }, _actionsItems && _actionsItems.map((item, index) => (item.title &&
            React.createElement(TouchableOpacity, { style: [{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        paddingHorizontal: 8,
                        paddingVertical: 8,
                        flex: 1,
                    },
                    (index === 0 && _actionsItems.length === 2) ? {
                        borderTopWidth: 1,
                        borderRightWidth: 1,
                        borderColor: '#E4E7EC'
                    } : (index === 0 || index === _actionsItems.length - 1) ? {
                        borderTopWidth: 1,
                        borderColor: '#E4E7EC'
                    } : (index > 0 && index < _actionsItems.length - 1) ? {
                        borderTopWidth: 1,
                        borderRightWidth: 1,
                        borderLeftWidth: 1,
                        borderColor: '#E4E7EC'
                    } : {},
                ], onPress: () => handeAction(index) },
                React.createElement(Typography, { label: item.title, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: ColorTokens.Primary_100, textAlign: TextAlignTokens.center, fontWeight: '600', lineHeight: 18 })))))));
};
export default memo(PartnerDetailsCard);
export { PartnerDetailsCard };
